import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Brain, Database, ArrowRight } from 'lucide-react';
export function TitleSlide() {
  return <div className="h-full flex flex-col justify-center relative" data-id="element-519">
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.8
    }} className="relative z-10" data-id="element-520">
        {/* Logo Area */}
        <motion.div initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="mb-8 inline-block" data-id="element-521">
          <div className="flex items-center gap-3 mb-2" data-id="element-522">
            <div className="w-10 h-10 rounded-full bg-purple-600 flex items-center justify-center shadow-lg shadow-purple-200" data-id="element-523">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-524">
                <path d="M8 5V19L19 12L8 5Z" fill="white" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-525" />
              </svg>
            </div>
            <span className="text-3xl font-bold tracking-tight text-gray-900 lowercase" data-id="element-526">
              snakker
            </span>
          </div>
        </motion.div>

        {/* Main Title */}
        <motion.h1 initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.4
      }} className="text-6xl md:text-7xl font-bold leading-tight mb-6 text-gray-900" data-id="element-527">
          Service-as-Software for
          <br data-id="element-528" />
          <span className="text-purple-600" data-id="element-529">Life Sciences Marketing</span>
        </motion.h1>

        {/* Subtitle / Value Prop */}
        <motion.div initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.6
      }} className="flex flex-wrap gap-6 text-xl text-gray-500 mb-12 items-center" data-id="element-530">
          <span className="flex items-center gap-2" data-id="element-531">
            <Brain className="w-5 h-5 text-purple-600" data-id="element-532" />
            AI-Native Runtime
          </span>
          <span className="w-1.5 h-1.5 rounded-full bg-purple-200" data-id="element-533" />
          <span className="flex items-center gap-2" data-id="element-534">
            <TrendingUp className="w-5 h-5 text-purple-600" data-id="element-535" />
            Recurring Revenue
          </span>
          <span className="w-1.5 h-1.5 rounded-full bg-purple-200" data-id="element-536" />
          <span className="flex items-center gap-2" data-id="element-537">
            <Database className="w-5 h-5 text-purple-600" data-id="element-538" />
            Compounding Behavioral Data
          </span>
        </motion.div>

        {/* Footer Info */}
        <motion.div initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.8
      }} className="flex items-center gap-6 pt-8 border-t border-gray-200" data-id="element-539">
          <div className="text-gray-400 font-mono" data-id="element-540">February 2026</div>
          <div className="h-4 w-px bg-gray-200" data-id="element-541" />
          <div className="px-4 py-1.5 rounded-full bg-purple-50 border border-purple-200 text-purple-600 font-medium text-sm flex items-center gap-2" data-id="element-542">
            Raising €2M <ArrowRight className="w-3 h-3" data-id="element-543" />
          </div>
        </motion.div>
      </motion.div>

      {/* Decorative Curve */}
      <svg className="absolute right-[-10%] top-1/2 -translate-y-1/2 h-[120%] w-[50%] opacity-30 pointer-events-none" viewBox="0 0 100 200" preserveAspectRatio="none" data-id="element-544">
        <path d="M0 200 C 40 150, 60 100, 100 0" stroke="url(#gradient)" strokeWidth="2" fill="none" data-id="element-545" />
        <defs data-id="element-546">
          <linearGradient id="gradient" x1="0%" y1="100%" x2="100%" y2="0%" data-id="element-547">
            <stop offset="0%" stopColor="transparent" data-id="element-548" />
            <stop offset="50%" stopColor="#A855F7" data-id="element-549" />
            <stop offset="100%" stopColor="#C084FC" data-id="element-550" />
          </linearGradient>
        </defs>
      </svg>
    </div>;
}